export enum PaginationItemsAmount {
  MIN = 1,
  DEFAULT = 10,
  MAX = 100
}

export const PAGINATION_START_PAGE = 1
